// extracted by mini-css-extract-plugin
module.exports = {"root":"hero_root__1I76e","outer":"hero_outer__WeBeP","inner":"hero_inner__WVA7A","findCompanyWrapper":"hero_findCompanyWrapper__2qz_5","otherContent":"hero_otherContent__2l0Mu"};